module.exports = __webpack_public_path__ + "static/media/hn.9712b4f7.svg";